export default {"src":"/_next/static/media/protection-solaire.74c47191.svg","height":64,"width":70,"blurWidth":0,"blurHeight":0};